
<p-button
appPreventDoubleClick
pTooltip="Check Out"
tooltipPosition="left"
icon="fas fa-lock"
id="formattedDocumentPreviewButton"
iconPos="left"
(debounceClick)="fileCheckedOut()"
></p-button>
